module.exports = __webpack_public_path__ + "static/media/LK_Information_Dark.712bb243.svg";